import { render, staticRenderFns } from "./RecomOrderRefund.vue?vue&type=template&id=613b12f4"
import script from "./RecomOrderRefund.vue?vue&type=script&lang=js"
export * from "./RecomOrderRefund.vue?vue&type=script&lang=js"
import style0 from "./RecomOrderRefund.vue?vue&type=style&index=0&id=613b12f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports